/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { BookingListBookingConnectionFragmentDoc } from '../../../components/organisms/BookingList/BookingList.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type BookingCancelReason =
  | 'ENTRANCE_CANCELLED'
  | 'USER_CANCELLED';

export type FetchCalendarBookingsByCalendarGuidQueryVariables = Exact<{
  guid: string | number;
  first: number;
  after?: string | null | undefined;
}>;


export type FetchCalendarBookingsByCalendarGuidQuery = { calendarDetail:
    | { __typename: 'CalendarDetailNotFound' }
    | { __typename: 'CalendarDetailPermissionDenied' }
    | { __typename: 'CalendarDetailSuccess', calendar: { bookings: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: { guid: string, startsAt: TimeString, endsAt: TimeString, cancelReason: Types.BookingCancelReason | null, summary: string | null, assignedStaff: { displayName: string } } }> } } }
   };


export const FetchCalendarBookingsByCalendarGuidDocument = gql`
    query FetchCalendarBookingsByCalendarGUID($guid: ID!, $first: Uint!, $after: String) {
  calendarDetail(guid: $guid) {
    __typename
    ... on CalendarDetailSuccess {
      calendar {
        bookings(first: $first, after: $after) {
          ...BookingListBookingConnection
        }
      }
    }
  }
}
    ${BookingListBookingConnectionFragmentDoc}`;

/**
 * __useFetchCalendarBookingsByCalendarGuidQuery__
 *
 * To run a query within a Vue component, call `useFetchCalendarBookingsByCalendarGuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCalendarBookingsByCalendarGuidQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchCalendarBookingsByCalendarGuidQuery({
 *   guid: // value for 'guid'
 *   first: // value for 'first'
 *   after: // value for 'after'
 * });
 */
export function useFetchCalendarBookingsByCalendarGuidQuery(variables: FetchCalendarBookingsByCalendarGuidQueryVariables | VueCompositionApi.Ref<FetchCalendarBookingsByCalendarGuidQueryVariables> | ReactiveFunction<FetchCalendarBookingsByCalendarGuidQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchCalendarBookingsByCalendarGuidQuery, FetchCalendarBookingsByCalendarGuidQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchCalendarBookingsByCalendarGuidQuery, FetchCalendarBookingsByCalendarGuidQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchCalendarBookingsByCalendarGuidQuery, FetchCalendarBookingsByCalendarGuidQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchCalendarBookingsByCalendarGuidQuery, FetchCalendarBookingsByCalendarGuidQueryVariables>(FetchCalendarBookingsByCalendarGuidDocument, variables, options);
}
export function useFetchCalendarBookingsByCalendarGuidLazyQuery(variables?: FetchCalendarBookingsByCalendarGuidQueryVariables | VueCompositionApi.Ref<FetchCalendarBookingsByCalendarGuidQueryVariables> | ReactiveFunction<FetchCalendarBookingsByCalendarGuidQueryVariables>, options: VueApolloComposable.UseQueryOptions<FetchCalendarBookingsByCalendarGuidQuery, FetchCalendarBookingsByCalendarGuidQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchCalendarBookingsByCalendarGuidQuery, FetchCalendarBookingsByCalendarGuidQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchCalendarBookingsByCalendarGuidQuery, FetchCalendarBookingsByCalendarGuidQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchCalendarBookingsByCalendarGuidQuery, FetchCalendarBookingsByCalendarGuidQueryVariables>(FetchCalendarBookingsByCalendarGuidDocument, variables, options);
}
export type FetchCalendarBookingsByCalendarGuidQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchCalendarBookingsByCalendarGuidQuery, FetchCalendarBookingsByCalendarGuidQueryVariables>;